exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:800&display=swap&text=NCBLibray);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Noto+Sans+JP:300,500,900);", ""]);
exports.push([module.id, "@import url(https://use.fontawesome.com/releases/v5.8.1/css/all.css);", ""]);

// module
exports.push([module.id, "@media all and (min-width: 1200px), print {\n.sp {\n    display: none;\n}\n}\n.sort {\n  margin-left: 5px;\n}", ""]);

// exports
